module.exports = __webpack_public_path__ + "img/logo.24d380f6.png";